import { withDependencies } from '@wix/thunderbolt-ioc'
import { IExternalComponentCssApplier } from '../types'

const BYOC_CSS_PARENT_ID = 'byoc-css'
const DATA_ATTRIBUTE = 'data-comp-href'

export const ExternalComponentCssApplier = withDependencies<IExternalComponentCssApplier>([], () => {
	const getCssParent = () => window.document.getElementById(BYOC_CSS_PARENT_ID)!

	const getCssModuleTag = (url: string) => {
		return getCssParent().querySelector(`[${DATA_ATTRIBUTE}="${url}"]`)
	}

	return {
		getLoadedModules() {
			const modules: Record<string, string> = {}
			Array.from(getCssParent().children)
				.filter((node) => node.hasAttribute(DATA_ATTRIBUTE))
				.forEach((node) => {
					modules[node.getAttribute(DATA_ATTRIBUTE)!] = node.textContent!
				})
			return modules
		},
		add(url, css) {
			if (getCssModuleTag(url)) {
				return
			}
			const styleElement = window.document.createElement('style')
			styleElement.setAttribute(DATA_ATTRIBUTE, url)
			styleElement.innerHTML = css
			getCssParent().appendChild(styleElement)
		},
		remove(url) {
			const styleTag = getCssModuleTag(url)
			if (styleTag) {
				styleTag.remove()
			}
		},
		update(url, css) {
			const styleTag = getCssModuleTag(url)
			if (styleTag) {
				styleTag.innerHTML = css
			}
		},
	}
})
